var App = App || {};

App.Cookies = (function () {
    'use strict';

    /* =========================================================================
    Helpers
    ========================================================================= */

    function getCookie(key) {

        if (!key) {
            return null;
        }

        return decodeURIComponent(document.cookie.replace(
            new RegExp(
                "(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"
            ),
            "$1"
        )) || null;
    }

    function setCookie(key, value, expires, path, domain, isSecure) {

        if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
            return false;
        }

        var expiresString = "";
        if (expires) {
            switch (expires.constructor) {
                case Number:
                    expiresString = expires === Infinity
                        ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
                        : "; max-age=" + expires;
                    break;
                case String:
                    expiresString = "; expires=" + expires;
                    break;
                case Date:
                    expiresString = "; expires=" + expires.toUTCString();
                    break;
            }
        }

        document.cookie =
            encodeURIComponent(key) + "=" + encodeURIComponent(value) +
            expiresString +
            (domain ? "; domain=" + domain : "") +
            (path ? "; path=" + path : "") +
            (isSecure ? "; secure" : "");
        return true;
    }

    function removeCookie(key, path, domain) {

        if (!hasCookie(key)) {
            return false;
        }

        document.cookie =
            encodeURIComponent(key) +
            "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
            (domain ? "; domain=" + domain : "") +
            (path ? "; path=" + path : "");
        return true;
    }

    function hasCookie(key) {

        if (!key) {
            return false;
        }

        return (new RegExp(
            "(?:^|;\\s*)" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\="
        )).test(document.cookie);
    }

    function getCookieKeys() {

        var keys = document.cookie.replace(
            /((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g,
            ""
        ).split(/\s*(?:\=[^;]*)?;\s*/);

        for (var i = 0, len = keys.length; i < len; i++) {
            keys[i] = decodeURIComponent(keys[i]);
        }
        return keys;
    }

    /* =========================================================================
    Public API Exposure
    ========================================================================= */

    return {
        getCookie,
        setCookie,
        removeCookie,
        hasCookie,
        getCookieKeys
    };

})();